import './VideoHolder.css'

import { useEffect, useRef } from 'react'

import { getPadding, paddingStyleProps } from '@/utilities/padding'

export interface VideoProps {
  url: string
  altText?: string
  type: 'youtube' | 'vimeo' | 'asset'
}

type ItemProps = {
  video: VideoProps[]
  hideMute?: boolean
  loopVideo?: boolean
  autoPlayVideo?: boolean
  closedCaptions?: boolean
  paddingTop?: paddingStyleProps[]
  paddingBottom?: paddingStyleProps[]
  checkVideoVisible?: boolean | null
  setWidth?: number
  layout?: string
}

export const PhnxVideoHolder = ({
  video,
  hideMute,
  loopVideo,
  autoPlayVideo,
  closedCaptions,
  paddingTop = [{ type: 'none', customPaddingUnit: 'em' }],
  paddingBottom = [{ type: 'none', customPaddingUnit: 'em' }],
  checkVideoVisible = null,
  setWidth = 100,
  layout,
}: ItemProps) => {
  const vimeoRef = useRef<HTMLIFrameElement>(null)
  const youtubeRef = useRef<HTMLIFrameElement>(null)

  // this is for the asset fader which has the background video
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (vimeoRef.current) {
        if (checkVideoVisible) {
          // Video is visible
          const iframe = vimeoRef.current
          autoPlayVideo &&
            iframe.contentWindow?.postMessage(JSON.stringify({ method: 'play' }), '*')
        } else {
          // Video is not visible
          const iframe = vimeoRef.current
          iframe.contentWindow?.postMessage(JSON.stringify({ method: 'pause' }), '*')
          iframe.contentWindow?.postMessage(
            JSON.stringify({ method: 'setCurrentTime', value: 0 }),
            '*'
          )
        }
      } else if (youtubeRef.current) {
        document.querySelectorAll('iframe').forEach((v) => {
          v.src = v.src
        })
        const iframe = document.getElementById('youtubeframe') as HTMLIFrameElement
        if (iframe) {
          document.querySelectorAll('video').forEach((v) => {
            v.pause()
          })
        }
      }
    }

    checkVideoVisible !== null && handleVisibilityChange()
  }, [autoPlayVideo, checkVideoVisible])

  // if no video return null
  if (video === null || video === undefined || video.length === 0) {
    return null
  }

  let bLoopVideo = 0
  if (loopVideo == true) {
    bLoopVideo = 1
  }

  let bAutoPlayVideo = 0
  let bMuted = 0
  if (autoPlayVideo == true) {
    bAutoPlayVideo = 1
    bMuted = 1
  }

  let bHideMuted = 0
  if (hideMute == true) {
    bHideMuted = 1
  }

  let bClosedCaptions = 0
  let bClosedCaptionsVimeo = 'NULL'
  if (closedCaptions == true) {
    if (video[0].type === 'vimeo') {
      bClosedCaptionsVimeo = 'en-x-autogen'
    } else {
      bClosedCaptions = 1
    }
  }

  let videoUrl = video[0]?.url ? video[0].url : ''
  let videoStyle = 'assetRatio'

  if (video[0]?.type === 'youtube') {
    videoUrl =
      'https://www.youtube.com/embed/' +
      video[0].url +
      '?loop=' +
      bLoopVideo +
      '&mute=' +
      bMuted +
      '&autoplay=' +
      bAutoPlayVideo +
      '&playlist=' +
      video[0].url +
      '&cc_load_policy=' +
      bClosedCaptions +
      '&cc_lang_pref=en'
    videoStyle = 'youtubeRatio'
  }
  if (video[0]?.type === 'vimeo') {
    // check if video url containss ? or not
    let track = '?'
    if (video[0].url.includes('?')) {
      track = '&'
    }
    videoUrl =
      'https://player.vimeo.com/video/' +
      video[0].url +
      `${track}texttrack=` +
      bClosedCaptionsVimeo +
      '&autoplay=' +
      bAutoPlayVideo +
      '&muted=' +
      bMuted +
      '&background=' +
      bHideMuted +
      '&loop=' +
      bLoopVideo +
      '&autopause=0'
    videoStyle = 'vimeoRatio'
  }

  // useEffect(() => {
  //   fitVids()
  // })
  let stringToQuery =
    'https://noembed.com/embed?url=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3D' + video[0].url
  if (video[0]?.type === 'vimeo') {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    stringToQuery = 'https://noembed.com/embed?url=https%3A%2F%2Fvimeo.com%2F' + video[0]?.url
  }

  let padding = getPadding(paddingTop, paddingBottom)

  const layoutClass = layout === 'center' ? 'center' : undefined

  return (
    <div
      style={{ width: setWidth ? `${setWidth}%` : '100%', height: '100%' }}
      className={layoutClass}
    >
      <div
        className={`videoHolder ${checkVideoVisible !== null ? 'assetCarouselClass' : ''} ${videoStyle} pt-${paddingTop[0].type} pb-${paddingBottom[0].type}`}
        style={padding.paddingStyle}
      >
        {video[0].type === 'youtube' && (
          <iframe
            id={'youtubeframe'}
            ref={youtubeRef}
            height="113"
            width="200"
            src={videoUrl + '?rel=0'}
            title="YouTube video player"
            allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          ></iframe>
        )}

        {video[0].type === 'vimeo' && (
          <iframe
            ref={vimeoRef}
            src={videoUrl}
            height="267"
            title="Vimeo video player"
            allow="autoplay; fullscreen; picture-in-picture"
          ></iframe>
        )}
      </div>
    </div>
  )
}
